import React from 'react'
import { StoredIndividualization } from '../../../../types/Individualization'
import { useTranslation } from 'react-i18next'
import cx from 'classnames'
import styles from './IndividualizationGrid.module.css'
import IndividualizationCard from '../IndividualizationCard/IndividualizationCard'
import IndividualizationCreateCard from '../IndividualizationCreateCard/IndividualizationCreateCard'

type IndividualizationGridProps = {
    individualizations: StoredIndividualization[]
    toggleVisibility: (individualization_id: number) => void
    createIndividualization: () => void
    deleteIndividualization: (individualization_id: number) => void
    editIndividualization: (individualization_id: number) => void
    copyIndividualization: (individualization_id: number) => void
    demoIndividualization: (individualization_id: number) => void
}

const IndividualizationGrid: React.FC<IndividualizationGridProps> = ({
    individualizations,
    createIndividualization,
    deleteIndividualization,
    editIndividualization,
    copyIndividualization,
    demoIndividualization,
    toggleVisibility,
}) => {
    const { t } = useTranslation(['individualization'])

    return (
        <div className={cx(styles['card-grid'])}>
            {individualizations.length === 0 && (
                <IndividualizationCreateCard
                    text={t('overview.add')}
                    openCreateModal={() => createIndividualization()}
                />
            )}
            {individualizations.map((data: StoredIndividualization) => (
                <IndividualizationCard
                    key={data.id}
                    individualization={data}
                    toggleVisibility={toggleVisibility}
                    deleteIndividualization={deleteIndividualization}
                    editIndividualization={editIndividualization}
                    copyIndividualization={copyIndividualization}
                    demoIndividualization={demoIndividualization}
                />
            ))}
        </div>
    )
}

export default IndividualizationGrid
